module.exports = __webpack_public_path__ + "static/media/pi1.28549191.jpg";